import { Icons } from '@agro-club/agroclub-shared'
import { ListRequestParams } from 'modules/domain/types'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { AButton } from 'views/components/Analytics'
import { Breadcrumbs, Header, PageName, TopHeader } from 'views/layouts/NewLayout'
import { RatesTabTypes } from 'views/pages/LogisticsKR/Rates/types'
import * as HeaderLayout from 'views/ui/Header/Header'
import { RatesFilters } from '../RatesFilters'

interface Props {
  listRequestParams: ListRequestParams
  updateFilterState: (filterObj: Record<string, any>) => void
  clearAllTabsState: (defaultParams: Record<string, any>) => void
  isEditingAvailable?: boolean
  setIsEditModalOpen?: (value: boolean) => void
  setIsAddRoadsOpen: (value: boolean) => void
  setIsAddRailsOpen: (value: boolean) => void
}

export const RatesListHeader = ({
  listRequestParams,
  updateFilterState,
  clearAllTabsState,
  isEditingAvailable,
  setIsEditModalOpen,
  setIsAddRoadsOpen,
  setIsAddRailsOpen,
}: Props) => {
  const { t } = useTranslation('rates')
  const { activeTab } = useParams()
  const isAverage = activeTab === RatesTabTypes.average
  const isRails = [RatesTabTypes.cerealsRails, RatesTabTypes.oilseedsRails].includes(activeTab as RatesTabTypes)

  return (
    <Header>
      <TopHeader>
        <Breadcrumbs routes={[{ breadcrumbName: t('heading') }]} />
        {!isAverage && (
          <HeaderLayout.AbsoluteButtonWrapper>
            <AButton
              id="edit"
              color="secondary"
              size="medium"
              disabled={!isEditingAvailable}
              onClick={() => setIsEditModalOpen?.(true)}
            >
              {t('editMultiple')}
            </AButton>

            <AButton
              id="add"
              Icon={Icons.IconAdd}
              color="approve"
              size="medium"
              onClick={() => (isRails ? setIsAddRailsOpen(true) : setIsAddRoadsOpen(true))}
            >
              {t('common:add')}
            </AButton>
          </HeaderLayout.AbsoluteButtonWrapper>
        )}
      </TopHeader>

      <PageName>{t('heading')}</PageName>

      <RatesFilters
        listRequestParams={listRequestParams}
        updateFilterState={updateFilterState}
        clearAllTabsState={clearAllTabsState}
      />
    </Header>
  )
}
